/**
 * Format a number as Euro currency
 */
export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '-'
  }
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

/**
 * Format a date for display
 */
export function formatDate(date: Date | null | undefined): string {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return '-'
  }
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date)
}

/**
 * Format a date for display in charts
 */
export function formatMonthYear(date: Date): string {
  return new Intl.DateTimeFormat('de-DE', {
    month: 'short',
    year: '2-digit',
  }).format(date)
}

/**
 * Get month name in German
 */
export function getMonthName(monthIndex: number, year: number): string {
  const date = new Date(year, monthIndex, 1)
  return new Intl.DateTimeFormat('de-DE', {
    month: 'short',
    year: '2-digit',
  }).format(date)
}

/**
 * Format a large number with K suffix
 */
export function formatCompactNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '-'
  }
  // German compact notation only abbreviates from a million up, so anything
  // below that stays a plain number — and a decimal on "732.980,5" is noise
  // when the exact figure already sits in the line underneath.
  const decimals = Math.abs(value) >= 10_000 ? 0 : 1
  return new Intl.NumberFormat('de-DE', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: decimals,
  }).format(value)
}
